export const CLOSE_RECOMMENDED_BROWSERS_DIALOG =
  'loginSessionSettings/CLOSE_RECOMMENDED_BROWSERS_DIALOG'
export const SHOW_RECOMMENDED_BROWSERS_DIALOG =
  'loginSessionSettings/SHOW_RECOMMENDED_BROWSERS_DIALOG'
